import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { DetailedTradeHistoryRoutingModule } from '@pg-app/client/detailed-trade-history/detailed-trade-history-routing.module';
import { DetailedTradeHistoryComponent } from '@pg-app/client/detailed-trade-history/detailed-trade-history.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { PipeModule } from '@nttp/pipes/pipe.module';

@NgModule({
    imports: [
        CommonModule,
        CoreUiModule,
        CoreMaterialModule,
        ReactiveFormsModule,
        DetailedTradeHistoryRoutingModule,
        NgxChartsModule,
        DragDropModule,
        NgTableModule,
        PipeModule

    ],
    declarations: [DetailedTradeHistoryComponent],
})
export class DetailedTradeHistoryModule { }
